import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { DividendData } from "../types";
import { loadDividend } from "../thunks/loadDividend";

export const useDisplayDividend = (tradeId?: string) => {
  const storeDividend = useSelector<StoreType, DividendData | undefined>(
    (store) => store.data.reports.dividends.displayDividend
  );

  const displayedDividend =
    storeDividend && storeDividend.tranId === tradeId ? storeDividend : undefined;

  const displatch = useDispatch();

  React.useEffect(() => {
    if (tradeId) {
      displatch(loadDividend(tradeId));
    }
  }, [displatch, tradeId]);

  return displayedDividend;
};
